(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lsc-clinical-results"] && !Shopify.designMode) return;
  try {
    
  /*
   * <lsc-clinical-pie>
   * LSC - Animates one clinical result: the pie (or ring) fills from 0 to
   * its percentage while the number counts up from 0 to its value, both on
   * the same eased timeline so they land together.
   *
   * Markup it expects (rendered by sections/lsc-clinical-results.liquid):
   *   data-value     the number as entered, e.g. "92" or "87.5"
   *   data-percent   the same value clamped to 0-100, used for the chart
   *   data-duration  seconds the animation runs
   *   [data-lsc-arc] the SVG circle whose stroke-dasharray draws the fill
   *   [data-lsc-num] the span holding the visible number
   *
   * The server renders the FINAL state, so if this script never runs the
   * visitor still sees the correct chart and number.
   */
  (function () {
    // Guard: the section can appear more than once, and the theme editor
    // re-runs scripts; define the element only once.
    if (customElements.get('lsc-clinical-pie')) return;

    // Respect the visitor's motion preference.
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // easeOutCubic: fast start, gentle landing, which reads well for counters.
    function ease(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    class LscClinicalPie extends HTMLElement {
      connectedCallback() {
        // connectedCallback can fire again if the node is moved; set up once.
        if (this._lscInit) return;
        this._lscInit = true;

        this.arc = this.querySelector('[data-lsc-arc]');
        this.num = this.querySelector('[data-lsc-num]');
        if (!this.arc || !this.num) return;

        this.rawValue = (this.dataset.value || '').trim();
        this.value = parseFloat(this.rawValue) || 0;
        this.percent = Math.max(0, Math.min(100, parseFloat(this.dataset.percent) || 0));
        this.duration = Math.max(0.2, parseFloat(this.dataset.duration) || 2) * 1000;

        // Keep the same number of decimals as the merchant entered ("87.5" -> 1).
        var dot = this.rawValue.indexOf('.');
        this.decimals = dot === -1 ? 0 : this.rawValue.length - dot - 1;

        // No animation wanted, or no observer support: leave the final state.
        if (reduceMotion || !('IntersectionObserver' in window)) return;

        // Reset to zero, then wait until the chart is on screen.
        this.draw(0);
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
          threshold: 0.35
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      onIntersect(entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        this.observer.disconnect(); // animate once per page view
        this.start = null;
        this.frame = requestAnimationFrame(this.tick.bind(this));
      }

      tick(now) {
        if (this.start === null) this.start = now;
        var t = Math.min(1, (now - this.start) / this.duration);
        this.draw(ease(t));
        if (t < 1) {
          this.frame = requestAnimationFrame(this.tick.bind(this));
        } else {
          // Finish on the exact string the merchant entered, no rounding drift.
          this.num.textContent = this.rawValue;
        }
      }

      // progress runs 0 -> 1; both the chart and the number follow it.
      draw(progress) {
        var p = this.percent * progress;
        this.arc.setAttribute('stroke-dasharray', p.toFixed(2) + ' 100');
        // A round-capped ring at 0 would still show a dot, so hide it there.
        this.arc.style.opacity = p < 0.5 ? '0' : '';
        this.num.textContent = (this.value * progress).toFixed(this.decimals);
      }
    }

    customElements.define('lsc-clinical-pie', LscClinicalPie);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lsc-video-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
  // Remove `autoplay` from this section type's players when the visitor prefers
  // reduced motion. <video-media> (assets/theme.js) then shows the poster plus a
  // play button instead of starting the loop. No preference = nothing happens.
  function lscVtoStopAutoplay(root) {
    // Feature-detect, then bail out quickly for the common (no preference) case.
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var players = (root || document).querySelectorAll('.lsc-vto__stage video-media[autoplay]');
    for (var i = 0; i < players.length; i++) players[i].removeAttribute('autoplay');
  }

  // Page load: every instance at once (this bundle runs once per page).
  lscVtoStopAutoplay(document);

  // Theme editor: a section re-rendered in place. Registered once per page load
  // (the bundle is not re-executed), so listeners never stack.
  document.addEventListener('shopify:section:load', function (event) {
    lscVtoStopAutoplay(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
